<template>
  <div class="action-mage content-430">
    <Table :columns="columns" :data="tableData" border>
      <template slot="operationType" slot-scope="{ row }"> 运营平台 </template>
      <template slot="action" slot-scope="{ row }">
        <span class="ordinary-color-430" @click="handleToMage(row)">管理</span>
      </template>
    </Table>
  </div>
</template>

<script>
import operationAdmin from '@/request/operationAdmin/index.js';
export default {
  data() {
    return {
      tableData: [],
      columns: [{
        title: '单位名称',
        key: 'name'
      }, {
        title: '单位类型',
        slot: 'operationType',
      }, {
        title: '法人',
        key: 'legalPerson',
      }, {
        title: '单位联系人姓名',
        key: 'contactName',
      }, {
        title: '更新时间',
        key: 'operateTime',
      }, {
        title: '操作',
        slot: 'action',
        width: 100
      },]
    }
  },
  created() {
    this.getAdminOrgPage()
  },
  methods: {
    async getAdminOrgPage() {
      let res = await operationAdmin.getAdminOrgPage({
        pageSize: 10,
        pageNum: 1
      })
      if (res.status == 200) {
        this.tableData = res.message.list
      }
    },
    handleToMage(row) {
      this.$router.push({
        name: 'basicInfoCenter_company_operationAction',
        query: { orgId: row.orgId }
      });

    }
  }
}
</script>

<style lang="scss" scoped>
</style>